import { collection, addDoc, query, where, getDocs, serverTimestamp } from "firebase/firestore";

import { firestore } from "./FirebaseService";
import { getAuthUserId, isAuthUserInStudy } from "./AuthService";
import QuestionnaireDefinitions from "../data/questionnaires/QuestionnaireDefinitions";

const questionnaireCollection = collection(firestore, "questionnaires");

export const fetchQuestionnaires = async (userId) => {
  const q = query(
    questionnaireCollection,
    where("userId", "==", userId)
  );
  const querySnapshot = await getDocs(q);
  const questionnaires = querySnapshot.docs.map(doc => {
    const questionnaireData = doc.data();
    return {
      questionnaireId: questionnaireData.questionnaireId,
      phase: questionnaireData.phase,
      createdAt: questionnaireData.createdAt
    };
  });
  return questionnaires;
};

export const fetchQuestionnaire = async (phase, questionnaireId, userId) => {
  const q = query(
    questionnaireCollection,
    where("phase", "==", phase),
    where("questionnaireId", "==", questionnaireId),
    where("userId", "==", userId)
  );
  const querySnapshot = await getDocs(q);
  if (querySnapshot.empty) {
    return null; // No questionnaire found
  }

  const questionnaireData = querySnapshot.docs[0].data();
  const questionnaireDef = QuestionnaireDefinitions[questionnaireId];
  const unflattenedAnswers = unflattenAnswers(questionnaireData.answers, questionnaireDef);

  return {
    questionnaireId: questionnaireData.questionnaireId,
    phase: questionnaireData.phase,
    answers: unflattenedAnswers,
    createdAt: questionnaireData.createdAt
  };
};

export const fetchQuestionnairesForExport = async (userId) => {
  const q = query(
    questionnaireCollection,
    where("userId", "==", userId)
  );
  const querySnapshot = await getDocs(q);

  const questionnaires = querySnapshot.docs.map(doc => {
    const questionnaireData = doc.data();

    let questionnaireId = questionnaireData.questionnaireId;
    if (questionnaireId === "PAQ_A" || questionnaireId === "PAQ_C")
      questionnaireId = "AF";

    return {
      questionnaireId: questionnaireId,
      phase: questionnaireData.phase,
      answers: questionnaireData.answers
    };
  });

  return questionnaires;
};

export const submitQuestionnaire = async (questionnaireId, answers, phase) => {
  const isInStudy = await isAuthUserInStudy();
  if (!isInStudy) {
    throw new Error("No tienes permiso para responder cuestionarios.");
  }

  const flattenedAnswers = answers.flat();

  // Check if all questions are answered
  const allQuestionsAnswered = flattenedAnswers.every((answer) => {
    return answer !== undefined && answer !== null && answer !== "" && !Number.isNaN(answer);
  });

  if (!allQuestionsAnswered) {
    throw new Error("Por favor, completa todas las preguntas antes de enviar.");
  }

  // Check if a document with the same userId, questionnaireId, and phase exists
  const userId = getAuthUserId();
  const q = query(
    questionnaireCollection,
    where("userId", "==", userId),
    where("questionnaireId", "==", questionnaireId),
    where("phase", "==", phase)
  );

  const querySnapshot = await getDocs(q);
  if (!querySnapshot.empty) {
    throw new Error("Este cuestionario ya ha sido respondido por ti.");
  }

  const questionnaireData = {
    userId,
    questionnaireId,
    answers: flattenedAnswers,
    phase,
    createdAt: serverTimestamp()
  };
  await addDoc(questionnaireCollection, questionnaireData);
};

const unflattenAnswers = (flatAnswers, questionnaireDef) => {
  let index = 0;
  return questionnaireDef.questions.map((q) => {
    if (q.items) {
      const items = flatAnswers.slice(index, index + q.items.length);
      index += q.items.length;
      return items;
    }
    else {
      return flatAnswers[index++];
    }
  });
};